var React = require('react');

function CloseXInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.7 12.6a.9.9 0 0 1-.637-.263L6.3 7.573l-4.764 4.764a.9.9 0 1 1-1.272-1.274L5.027 6.3.264 1.536A.9.9 0 0 1 1.536.264L6.3 5.027 11.063.264a.9.9 0 1 1 1.274 1.272L7.573 6.3l4.764 4.763A.9.9 0 0 1 11.7 12.6z","fill":"currentColor"}));
}

CloseXInline.defaultProps = {"viewBox":"0 0 12.6 12.6"};

module.exports = CloseXInline;

CloseXInline.default = CloseXInline;
